import { Briefcase, MessageSquare, Settings, Images } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const SideBarMobile = () => {
  const location = useLocation();

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <nav className="navbar-dash-bottom">
      <div className="navbar-mobile navbar-visible">
        <ul className="navbar-links flex-row align-items-center space-around">
          <li>
            <Link to="/dashboard" className="flex-row-align">
              <Images color={isActive('/dashboard/gallery') ? '#26437c' : '#9ca3af'} />
            </Link>
          </li>
          <li>
            <Link to="/dashboard/products" className="flex-row-align">
              <Briefcase color={isActive('/dashboard/products') ? '#26437c' : '#9ca3af'} />
            </Link>
          </li>
          <li>
            <Link to="/dashboard/support" className="flex-row-align">
              <MessageSquare color={isActive('/dashboard/support') ? '#26437c' : '#9ca3af'} />
            </Link>
          </li>
          <li>
            <Link to="/dashboard/settings" className="flex-row-align">
              <Settings color={isActive('/dashboard/settings') ? '#26437c' : '#9ca3af'} />
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SideBarMobile;
